import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/go_shop.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3b53a125")

_pushScopeId("data-v-3b53a125")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "top-wrapper" }
const _hoisted_3 = { class: "nav-wrapper" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_6 = { class: "content-top-wrapper" }
const _hoisted_7 = { class: "content-top-wrapper-image" }
const _hoisted_8 = { class: "content-top-wrapper-intro" }
const _hoisted_9 = { class: "content-list-title" }
const _hoisted_10 = { class: "content-list-content-item-title" }
const _hoisted_11 = {
  key: 0,
  class: "content-list-content-item-intro"
}
const _hoisted_12 = {
  key: 1,
  class: "content-list-content-item-image"
}
const _hoisted_13 = {
  key: 0,
  class: "desc"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_ImgContainer = _resolveComponent("ImgContainer")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              key: k,
              class: `nav-item ${k === _ctx.currentNav ? 'active' : ''}`,
              onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
            }, [
              _createVNode("span", null, _toDisplayString(i.title), 1)
            ], 10, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", null, [
          (_ctx.currentNav === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_HotspotContentList, {
                  list: _ctx.modules.list[_ctx.currentNav].detail.list,
                  onAudiobgstop: _ctx.audiobgstop
                }, null, 8, ["list", "onAudiobgstop"])
              ]))
            : (_ctx.currentNav === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentNav].detail.top.title), 1),
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_ImgContainer, {
                        src: _ctx.modules.list[_ctx.currentNav].detail.top.cover
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentNav].detail.top.intro, (i, k) => {
                        return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                      }), 128))
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentNav].detail.list, (i, k) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "content-list-item",
                      key: k
                    }, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("span", null, _toDisplayString(i.title), 1)
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.content, (m, n) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "content-list-content-item",
                          key: n
                        }, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("span", null, _toDisplayString(m.title), 1)
                          ]),
                          (m.intro && m.intro.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(m.intro, (p, q) => {
                                  return (_openBlock(), _createBlock("p", { key: q }, _toDisplayString(p), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (m.imgs && m.imgs.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(m.imgs, (p, q) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "image",
                                    key: q
                                  }, [
                                    _createVNode(_component_ImgContainer, {
                                      src: p.img
                                    }, null, 8, ["src"]),
                                    (p.desc)
                                      ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(p.desc), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
          _createVNode("div", {
            class: "content-action",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goZsPage && _ctx.goZsPage(...args)), ["stop","prevent"]))
          }, [
            _hoisted_14
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})